export enum exceptionValidation {
  VALID = 'VALID',
  INVALID = 'INVALID',
  EMPTY = 'EMPTY',
  LENGTH_EXCEEDED = 'LENGTH_EXCEEDED'
}

export enum DataLoadingState {
  LOADING = 'LOADING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export const viewHelperText = {
  input_field: '(Start with a letter and use only valid characters: a-z, A-Z, 0-9, and hyphen (-))',
  dropdown_lbl: 'Select Type',
  description_field: '(Start with a letter and use only valid characters: a-z, A-Z, 0-9 and special characters (-, .))',
  txt_status: 'status',
  txt_date: 'date',
  txt_start_date: 'start_date',
  txt_end_date: 'end_date',
  error_404: '404'
};

/**
 * Represents the filter data for the exception list.
 * @interface ExceptionListFilterData
 */
export interface ExceptionListFilterData {
  startDate?: string;
  endDate?: string;
  status: string[];
}

/**
 * Represents the filter data for the starting filter.
 * @interface StartingFilterData
 */
export interface StartingFilterData {
  startDate?: Date;
  endDate?: Date;
  status: string[];
}

/**
 * Represents the props for a component.
 * @interface ExceptionListFilterProps
 */
export interface ExceptionListFilterProps {
  allStatusList: { label: string, value: string }[];
  data?: ExceptionListFilterData;
  onApply: (data: ExceptionListFilterData) => void;
  onResetFilters: () => void;
}

export enum ApiModifySort {
  ASC = 'ASC',
  DESC = 'DESC'
}
